import Home from "./Pages/Home/home.jsx";
import Edit from "./Pages/Edit/edit.jsx";
import Landing from "./Pages/Landing/landing.jsx";
import Features from "./Pages/Features/Features.js";
import FAQ from "./Pages/FAQ/faq.js";
import Pricing from "./Pages/Pricing/pricing.js";
import TermsCondition from "./Pages/TermsCondition/termsCondtions.js";
import ShareImage from "./Components/shareImage/ShareImage.jsx";
export const routes = [
  { path: "/", component: Landing },
  { path: "/features", component: Features },
  { path: "/pricing", component: Pricing },
  { path: "/faq", component: FAQ },
  { path: "/terms", component: TermsCondition },
  { path: "/home", component: Home },
  { path: "/addtemplate", component: Home },
  { path: "/edit", component: Edit },
  { path: "/shareimage", component: ShareImage },
];
